import { ChartType } from './apex.model';

const revenueBarChart: ChartType = {
  chart: {
    height: 340,
    type: 'line',
    stacked: true,
    toolbar: {
        show: false
    },
    zoom: {
        enabled: true
    }
  },
  plotOptions: {
    bar: {
        horizontal: false,
        columnWidth: '15%',
        borderRadius: 5,
        endingShape: 'rounded'
    },
  },
  dataLabels: {
    enabled: false
  },
  series: [{
    name: 'Sales',
    data: [44456, 55932, 41300, 67300, 22234, 43500, 36600, 52100],
  }],
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
  yaxis: {
    labels: {
      formatter: (val) => {
        return "$" + val;
      }
    }
  },
  colors: ['#202020'],
  legend: {
    position: 'bottom',
  },
  fill: {
    opacity: 1
  },
  tooltip: {
    x: {
      formatter: (val: number) => {
        return '$ ' + val;
      }
    }
  }
};

const statData = [{
  "icon": "bx bx-copy-alt",
  "title": "Orders",
  "value": "1,235"
}, {
  "icon": "bx bx-archive-in",
  "title": "Revenue",
  "value": "$35, 723"
}, {
  "icon": "bx bx-purchase-tag-alt",
  "title": "Total Merchants",
  "value": "10"
}];

const transactions =  [
  {
    "id": "#SK2540",
    "name": "Neal Matthews",
    "restaurantName": "Figaro",
    "locationName": "Figaro 1",
    "date": "07 Oct, 2019",
    "total": "$400",
    "status": "Paid",
    "payment": ["fa-cc-mastercard", "Mastercard"],
    "index": 1
  },
  {
    "id": "#SK2541",
    "name": "Jamal Burnett",
    "restaurantName": "Figaro",
    "locationName": "Figaro 1",
    "date": "07 Oct, 2019",
    "total": "$380",
    "status": "Refunded",
    "payment": ["fa-cc-visa", "Visa"],
    "index": 2
  },
  {
    "id": "#SK2542",
    "name": "Juan Mitchell",
    "restaurantName": "Azucanela",
    "locationName": "Azucanela 1",
    "date": "06 Oct, 2019",
    "total": "$384",
    "status": "Paid",
    "payment": ["fab fa-cc-discover", "Discover"],
    "index": 3
  },
  {
    "id": "#SK2543",
    "name": "Barry Dick",
    "restaurantName": "Sun Cafe",
    "locationName": "Sun Cafe 1",
    "date": "05 Oct, 2019",
    "total": "$412",
    "status": "Paid",
    "payment": ["fa-cc-mastercard", "Mastercard"],
    "index": 4
  },
  {
    "id": "#SK2544",
    "name": "Ronald Taylor",
    "restaurantName": "Sun Cafe",
    "locationName": "Sun Cafe 1",
    "date": "04 Oct, 2019",
    "total": "$404",
    "status": "Cancelled",
    "payment": ["fa-cc-visa", "Visa"],
    "index": 5
  },
  {
    "id": "#SK2545",
    "name": "Jacob Hunter",
    "restaurantName": "Figaro",
    "locationName": "Figaro 1",
    "date": "04 Oct, 2019",
    "total": "$392",
    "status": "Paid",
    "payment": ["fab fa-cc-paypal", "Discover"],
    "index": 6
  }
];

const alerts = [
  {
    date: "22 Aug",
    description: "New Merchant onboarded",
    link: "dayes@eatos.co",
    unread: false,
  },
  {
    date: "17 Aug",
    description: "Menu not configured properly (UCRAVE)",
    link: "",
    unread: false,
  },
  {
    date: "15 Aug",
    description: "Figaro license will expire on 23-Nov-2024",
    link: "",
    unread: true,
  },
  {
    date: "12 Aug",
    description: "New Merchant onboarded",
    link: "vickysbekry@eatos.co",
    unread: false,
  }
];

const revenueResponse = {
  intervals: [
    {
      key_as_string: "12-2023",
      key: 1701417600000,
      netSales: "0.00",
    },
    {
      key_as_string: "01-2024",
      key: 1704096000000,
      netSales: "86207.80",
    },
    {
      key_as_string: "02-2024",
      key: 1706774400000,
      netSales: "131197.41",
    },
    {
      key_as_string: "03-2024",
      key: 1709280000000,
      netSales: "353743.02",
    },
    {
      key_as_string: "04-2024",
      key: 1711954800000,
      netSales: "909751.04",
    },
    {
      key_as_string: "05-2024",
      key: 1714546800000,
      netSales: "229242.55",
    },
    {
      key_as_string: "06-2024",
      key: 1717225200000,
      netSales: "25311.30",
    },
    {
      key_as_string: "07-2024",
      key: 1719817200000,
      netSales: "40815.10",
    },
    {
      key_as_string: "08-2024",
      key: 1722495600000,
      netSales: "12376.30",
    },
    {
      key_as_string: "09-2024",
      key: 1725174000000,
      netSales: "0.00",
    },
    {
      key_as_string: "10-2024",
      key: 1727766000000,
      netSales: "0.00",
    },
    {
      key_as_string: "11-2024",
      key: 1730444400000,
      netSales: "0.00",
    },
    {
      key_as_string: "12-2024",
      key: 1733040000000,
      netSales: "0.00",
    },
  ],
};

const topMerchantsResponse = {
  "success": 1,
  "data": [
      {
          "merchantId": "63172dd71edd086984d8bc3b",
          "storeName": "Figaro",
          "totalOrder": 6249,
          "total": "15640281.21"
      },
      {
          "merchantId": "617ad835e499e8001b6d0780",
          "storeName": "Sun Cafe",
          "totalOrder": 1603,
          "total": "2204593.44"
      },
      {
          "merchantId": "6465dfa597ceb30657ee25d1",
          "storeName": "Azucanela",
          "totalOrder": 43,
          "total": "1001359.92"
      },
      {
          "merchantId": "6409d30a425c5c33c1722c67",
          "storeName": "Purple Turtle",
          "totalOrder": 1193,
          "total": "829495.01"
      },
      {
          "merchantId": "645c93dfdd3faad81e5a00f9",
          "storeName": "Langar Houz",
          "totalOrder": 2573,
          "total": "741067.16"
      }
  ],
};

const latestTransactionsResponse = {
  success: 1,
  data: [
    {
      payId: "@1wqw-18",
      storeName: "Cool",
      date: "2024-08-22 20:18:18",
      amount: "98.55",
      type: "Grubhub",
      typeId: 13,
      status: "Approved",
      serverName: "Neal Matthews",
      locationName: "Cool 1",
    },
    {
      payId: "P5@00-20",
      storeName: "Fantam Restaurant",
      date: "2024-08-22 20:10:25",
      amount: "19.24",
      type: "Cash",
      typeId: 1,
      status: "Approved",
      serverName: "Jamal Burnett",
      locationName: "Fantam Restaurant 1",
    },
    {
      payId: "94",
      storeName: "Demo Restaurant",
      date: "2024-08-22 20:08:04",
      amount: "27.38",
      type: "Cash",
      typeId: 1,
      status: "Approved",
      serverName: "Juan Mitchell",
      locationName: "Demo Restaurant 1",
    },
    {
      payId: "93",
      storeName: "Demo Restaurant",
      date: "2024-08-22 19:50:47",
      amount: "27.38",
      type: "Cash",
      typeId: 1,
      status: "Approved",
      serverName: "Ronald Taylor",
      locationName: "Demo Restaurant 2",
    },
    {
      payId: "92",
      storeName: "Demo Restaurant",
      date: "2024-08-22 19:44:43",
      amount: "27.38",
      type: "Cash",
      typeId: 1,
      status: "Approved",
      serverName: "Ronald Taylor",
      locationName: "Demo Restaurant 1",
    },
  ],
};

const alertResponse = [
  {
		subscriptionId: "66b46440a15088f3e2ef7c06",
		dueIn: 2,
		alertDate: 1724990400,
		alertType: "subscription",
		alertMessage: "Five restaurent subscription is due to expire in 2 days",
		createdAt: "2024-08-28T06:55:48.601Z",
		updatedAt: "2024-08-28T06:55:48.601Z",
		subscriptionAlertId: "66cec9f455811f4100f67301"
	}
];

export {
  revenueBarChart, statData, transactions, alerts, revenueResponse ,
  topMerchantsResponse, latestTransactionsResponse, alertResponse,
};
